// 二级页面
<template>
  <div class="page">
    <!-- 背景视频 -->
    <video class="video-background" id="bgVideo" autoplay muted loop>
      <source src="../../assets/bg2.mp4" type="video/mp4">
      <!-- <source src="https://s1.xiaomiev.com/activity-outer-assets/0328/images/Ultra_U/pc/ultra_2_1.mp4" type="video/mp4"> -->
      您的浏览器不支持视频标签。
    </video>
    <div class="container">
      <div ref="threeContainer" @click="onClick" class="model" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0,0,0,0)"></div>
      <!-- 二级页面左右结构 -->
      <div class="left_right">
        <div class="page_left">
          <div class="box box_l1">
            <h3 class="title">园区总览</h3>
            <div class="info" v-if="type==='xl'">
              <div class="intro" v-if="jsonData.subpage"><p v-for="(item,index) in jsonData.subpage.yqzl" :key="index">{{item}}</p></div>
            </div>
            <div class="info" v-else style="padding: 50px 0 50px 30px;"> 
              <div class="intro" v-if="jsonData.subpage"><p style="letter-spacing:0" v-for="(item,index) in jsonData.subpage.yqzl" :key="index">{{item}}</p></div>
            </div>
          </div>
          <div class="box box_l2" v-if="type==='xl'">
            <h3 class="title">设备概览</h3>
            <div class="main flx" v-if="jsonData.subpage">
              <img src="/assets/image/subpage/sbgl.png" />
              <div class="sbgl" v-for="(item,index) in jsonData.subpage.sbgl" :key="index" :class="'sbgl'+index">
                <span class="status" :class="item.status==='运行中'?'green':item.status==='调试中'?'blue':item.status==='建设中'?'red':''">{{item.status}}</span>
              </div>
            </div>
          </div>
          <div class="box box_l2" v-else>
            <h3 class="title">当月生产量</h3>
            <div class="main">
              <!-- <img src="/assets/image/subpage/dyscl.png" /> -->
              <div class="chart" id="dyscl"></div>
            </div>
          </div>
          <div class="action">
            <!-- <div class="action_btn" @click="actionShow=!actionShow">操作按钮</div> -->
            <div class="action_btn" @click="$router.go(-1)">返回</div>
            <div class="action_box" v-if="actionShow">
              <!-- <div class="flx-bc line line1">
                <div class="item" @click="doModel('rotate','left')">左旋</div>
                <div class="item" @click="doModel('rotate','right')">右旋</div>
              </div>
              <div class="flx-bc line">
                <div class="item" @click="doModel('scale','big')">放大</div>
                <div class="item" @click="doModel('scale','small')">缩小</div>
              </div> -->
              <div class="line" @click="$router.push('/index')">返回</div>
              <div class="line" @click="doModel('reset')">复位</div>
            </div>
          </div>
        </div>
        <div class="page_right">
          <div class="box box_r1" v-if="type==='xl'">
            <h3 class="title">能耗统计</h3>
            <div class="main">
              <!-- <img src="/assets/image/subpage/nhtj.png" /> -->
              <div class="chart" id="nhtj"></div>
            </div>
          </div>
          <div class="box box_r1" v-else>
            <h3 class="title">年生产计划</h3>
            <div class="main">
              <!-- <img src="/assets/image/subpage/nscjh.png" /> -->
              <div class="chart" id="nscjh"></div>
            </div>
          </div>
          <div class="box box_r2" v-if="type==='xl'">
            <h3 class="title">环境监测</h3>
            <div class="main">
              <img src="/assets/image/subpage/hjjc.png" />
              <div class="hjjc" :class="'hjjc'+index" v-for="(item,index) in jsonData.subpage.hjjc" :key="index">
                <label>{{item.name}}</label>
                <div class="hjjc_info">
                  <div class="item" v-for="(it,i) in item.data" :key="i">
                    <span>{{it.value}}</span>
                    <p>{{it.name}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box box_r2" v-else>
            <h3 class="title">年销售计划</h3>
            <div class="main">
              <!-- <img src="/assets/image/subpage/nxsjh.png" /> -->
              <div class="chart" id="nxsjh"></div>
            </div>
          </div>
          <div class="box box_r3">
            <h3 class="title">监控视频</h3>
            <div class="main">
              <video v-if="videoUrl" :src="videoUrl" controls class="video">
                Your browser does not support the video tag.
              </video>
              <img v-else src="/assets/image/subpage/jksp.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入 Three.js 核心
import * as THREE from 'three';
// 注意：从 three/examples/jsm/ 路径引入
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
// 如果需要轨道控制器
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
// 环境贴图
import { DebugEnvironment } from 'three/examples/jsm/environments/DebugEnvironment.js';

import axios from 'axios'
import echarts from 'echarts'
export default {
  name: 'My3DComponent',
  data() {
    return {
      type: '',
      actionShow: false,
      loading: true,
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      animationId: null,
      lastRender: 0, //模型渲染
      mixer: null,
      model:null,
      model2:null, //盖在上面的模型
      scale: 1,
      rotationY: - Math.PI / 2,
      clickableObjects: [], //可点击的对象模型（代理模型）

      jsonData: {subpage:''},
      videoUrl: ''
    };
  },
  created() {
    this.type = this.$route.query.type
    if(this.type==='xl'){
      this.getData('modelXl')
    }else{
      this.getData('modelWl')
    }
  },
  mounted() {
    // this.loading = false
    // 延迟 100ms 等待旧 context 回收
    setTimeout(() => {
      this.initThree();
      this.loadModel();
      // this.loadModel2();
      this.animate();
      window.addEventListener('resize', this.onWindowResize);
    }, 100);
  },
  beforeDestroy() {
    // 清理 Three.js 资源，防止内存泄漏
    this.cleanUp();
  },
  methods: {
    getData(name){
      let params = {fileName: name}
      axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
        if(res.data.code === 200){
          this.jsonData = res.data.data
          this.jsonData.subpage.yqzl = this.jsonData.subpage.yqzl.split('\n')
          this.videoUrl = this.jsonData.subpage.jksp
          
          if(this.type === 'xl'){
            this.$nextTick(() => {
                this.echarts('nhtj')
            })
          }else{
            this.$nextTick(() => {
                this.echarts('dyscl')
            })
            this.$nextTick(() => {
                this.echarts('nscjh')
            })
            this.$nextTick(() => {
                this.echarts('nxsjh')
            })
          }
        }
      })
    },
    echarts(type){
        var chart = null
        let datas = []
        let dataX = []
        let names = []
        let chartData = []
        let unit = ''
        let color = ['#085ba9','#33b2e9','#33e933','#ff9c00','#00fffc','#bac061','#d3f8ff']
        if(type==='nhtj'){
            chart = echarts.init(document.getElementById('nhtj'));
            chartData = this.jsonData.subpage.nhtj
        }else if(type==='dyscl'){
            chart = echarts.init(document.getElementById('dyscl'));
            chartData = this.jsonData.subpage.dyscl.data
            unit = this.jsonData.subpage.dyscl.unit
            color = ['#33b2e9','#33e933','#085ba9','#ff9c00','#00fffc','#bac061','#d3f8ff']
        }else if(type==='nscjh'){
            chart = echarts.init(document.getElementById('nscjh'));
            chartData = this.jsonData.subpage.nscjh.data
            unit = this.jsonData.subpage.nscjh.unit
            color = ['#bac061','#d3f8ff','#33b2e9','#33e933','#085ba9','#ff9c00','#00fffc']
        }else if(type==='nxsjh'){
            chart = echarts.init(document.getElementById('nxsjh'));
            chartData = this.jsonData.subpage.nxsjh.data
            unit = this.jsonData.subpage.nxsjh.unit
            color = ['#ff9c00','#00fffc','#085ba9','#33b2e9','#33e933','#bac061','#d3f8ff']
        }
        dataX = chartData[0].data.map(it => it.name)
        names = chartData.map(it => it.name)
        chartData.forEach(item => {
            let data = item.data.map(it => it.value)
            datas.push({
                data: data,
                name: item.name,
                type: 'bar',
                barWidth: 20,
                label: {
                    show: true,                    // 显示标签
                    position: 'top',               // 标签显示在柱子顶部
                    fontSize: 30,
                    color: '#fff',                 // 数值颜色
                    fontWeight: 'bold',
                    // 可选：格式化显示内容
                    formatter: '{c}',// {c} 表示数值，{a}系列名，{b}类目名
                },
            })
        });
        // 清空图表
        chart.clear();
        chart.setOption({
            // 设置绘图区域的边距
            grid: {
                left: 40,   // 左侧距离
                right: 80,  // 右侧距离
                top: 100,   // 可选：顶部距离
                bottom: 40, // 可选：底部距离
                containLabel: true // 确保标签不被裁剪
            },
            legend: {
                top: 30,
                data: names,
                textStyle: {
                    fontSize: 24,
                    color: '#fff',
                    padding:[0,10],
                },
            },
            tooltip: {
                trigger: 'item',
                textStyle: {
                    color: '#fff',
                    fontSize: 24,
                },
            },
            graphic: {
              elements: this.type==='wl'?[
                {
                  type: 'text',
                  left: '20',       // 距离容器左边 10px（也可用 '10%'）
                  top: '40',        // 距离容器顶部 10px
                  style: {
                    text: `单位：${unit}`,
                    fontSize: 20,
                    fill: '#fff',   // 文字颜色
                    textAlign: 'left'
                  }
                }
              ]:[]
            },
            color: color,
            xAxis: {
                type: 'category',
                data: dataX,
                axisTick: {
                    show: false
                },
                axisLine: {
                  show: true,
                    lineStyle: {
                      color: '#274c8e', // 设置 x 轴线的颜色
                    }
                },
                boundaryGap: false, // 去掉左右两边的空白
                axisLabel: {
                    color: '#fff', // 文字颜色
                    fontSize: 24,   // 字体大小
                    margin: 24,
                    // rotate: 45
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                  show: true,
                    lineStyle: {
                      color: '#274c8e', // 设置 x 轴线的颜色
                    }
                },
                splitLine: { 
                    lineStyle: {
                        color: '#274c8e', // 设置 x 轴线的颜色
                    } 
                },
                axisTick: { show: false },
                axisLabel: {
                    color: '#fff', // 文字颜色
                    fontSize: 24,   // 字体大小
                    margin: 60,
                    formatter: '{value}'
                }
            },
            series: datas,
        })
    },
    // 旋转，翻转模型
    doModel(type,value){
      // 原始大小
      let obj = {
        scale: 0.05,
        rotationY: - Math.PI / 2
      }
      if(type === 'scale'){
        if(value==='big'){
          this.scale += 0.1
        }else{
          this.scale -= 0.1
        }
        this.model.scale.set(obj.scale*this.scale, obj.scale*this.scale, obj.scale*this.scale);
        this.model2.scale.set(obj.scale*this.scale, obj.scale*this.scale, obj.scale*this.scale);
      }else if(type === 'rotate'){
        if(value==='left'){
          this.rotationY -= Math.PI / 2
        }else{
          this.rotationY += Math.PI / 2
        }
        this.model.rotation.y = this.rotationY;
        this.model2.rotation.y = this.rotationY;
      }else if(type === 'reset'){
        this.model.rotation.y = obj.rotationY;
        this.model.scale.set(obj.scale, obj.scale, obj.scale);
        this.model2.rotation.y = obj.rotationY;
        this.model2.scale.set(obj.scale, obj.scale, obj.scale);
        this.controls.reset();
      }
    },
    initThree() {
      // 创建场景
      this.scene = new THREE.Scene();
      // this.scene.background = new THREE.Color(0xffffff);
      this.scene.background = null; // 设置场景背景透明

      // 创建相机
      const width = this.$refs.threeContainer.offsetWidth;
      const height = this.$refs.threeContainer.offsetHeight;
      this.camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
      this.scene.add(this.camera);//将相机加入到场景中
      this.camera.position.z = 10;

      // 创建渲染器
      this.renderer = new THREE.WebGLRenderer({ antialias: true,alpha: true });
      this.renderer.setSize(width, height);
      this.renderer.setPixelRatio(window.devicePixelRatio);
      // 曝光调节
      this.renderer.outputEncoding = THREE.sRGBEncoding;
      this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
      this.renderer.toneMappingExposure = 1.5; // 调整此值来改变亮度
      this.renderer.setClearAlpha(0); // 设置背景透明度为0
      
      this.renderer.shadowMap.enabled = true;
      this.renderer.shadowMap.type = THREE.PCFSoftShadowMap; // 更柔和的阴影效果

      //Three.js 的 renderer.domElement 有时会自动获取焦点，导致媒体行为异常。可以禁用
      this.renderer.domElement.tabIndex = -1; // 防止聚焦
      this.renderer.domElement.style.outline = 'none'; // 可选：隐藏轮廓

      this.$refs.threeContainer.appendChild(this.renderer.domElement);

      
      // 使用 DebugEnvironment
      const environment = new DebugEnvironment();
      const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
      this.scene.environment = pmremGenerator.fromScene(environment).texture;

      // // 添加轨道控制器（可选）
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      //是否可以缩放
      this.controls.enableZoom = true;
      //是否自动旋转
      this.controls.autoRotate = false;
      //设置相机距离原点的最远距离
      this.controls.minDistance = 1;
      //设置相机距离原点的最远距离
      this.controls.maxDistance = 10;
      //是否开启右键拖拽
      this.controls.enablePan = true;

      // 添加环境光
      const ambientLight = new THREE.AmbientLight(0xffffff, .5);
      this.scene.add(ambientLight);
      // // 添加平行光
      // const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
      // directionalLight.position.set(1,1,1);
      // this.scene.add(directionalLight);
      const sunLight = new THREE.DirectionalLight(0xffffff, 5);
      sunLight.position.set(10, 10, -2);
      sunLight.castShadow = true;
      sunLight.shadow.mapSize.width = 2048;
      sunLight.shadow.mapSize.height = 2048;
      sunLight.shadow.camera.left = -15;
      sunLight.shadow.camera.right = 15;
      sunLight.shadow.camera.top = 15;
      sunLight.shadow.camera.bottom = -15;
      sunLight.shadow.camera.near = 0.5;
      sunLight.shadow.camera.far = 30;
      this.scene.add(sunLight);
    },
    loadModel() {
      const gltfLoader = new GLTFLoader();
      let url = this.type === 'wl' ? '/assets/3d/物理工厂.glb' : '/assets/3d/虚拟工厂.glb'
      // 加载 .glb 文件
      gltfLoader.load(
        url, 
        (gltf) => {
          this.loadModel2();
          // 模型加载成功
          console.log('模型加载成功:', gltf);
          const model = gltf.scene;
          model.scale.set(0.05, 0.05, 0.05);
          model.rotation.y = - Math.PI / 2;
          model.rotation.x = 0.4
          model.position.set(0,-1,0)
          if(this.type === 'wl'){
            model.traverse(function(child) {
              if (child.isMesh) {
                  child.castShadow = true;
                  child.receiveShadow = true;
              }
            });
          }
          this.scene.add(model)
          this.model = model
          this.loading = false
          
          // 获取动画混合器
          const animations = gltf.animations;
          if (animations && animations.length) {
            this.mixer = new THREE.AnimationMixer(gltf.scene);
            for (let i = 0; i < animations.length; i++) {
              const action = this.mixer.clipAction(animations[i]);
              action.play();
            }
          }
        },
        (xhr) => {
          // 加载进度回调
          // console.log('模型加载进度:', (xhr.loaded / xhr.total * 100) + '% loaded');
        },
        (error) => {
          // 加载错误回调
          console.error('模型加载失败:', error);
        }
      );
    },
    loadModel2() {
      let that = this
      const gltfLoader = new GLTFLoader();
      let url = this.type === 'wl' ? '/assets/3d/物理工厂分块点击.glb' : '/assets/3d/xunigongchangzhengti_button.glb'
      // 加载 .glb 文件
      gltfLoader.load(
        url, 
        (gltf) => {
          // 模型加载成功
          console.log('模型加载成功:', gltf);
          const model = gltf.scene;
          model.scale.set(0.05, 0.05, 0.05);
          model.rotation.y = - Math.PI / 2;
          model.rotation.x = 0.4
          model.position.set(0,-1,0)
          // 👉 设置上层模型不可见（或半透明用于调试）
          model.traverse((child) => {
              if (child.isMesh) {
                  // child.material.visible = false; // 完全不可见
                  // child.material.transparent = true;
                  // child.material.opacity = 0.3; // 半透明，便于调试
                  if(child.name.indexOf('button')>-1){
                    child.material.visible = false; // 完全不可见
                  }
                  that.clickableObjects.push(child);
              }
          });
          this.scene.add(model)
          this.model2 = model
        },
        (xhr) => {
          // 加载进度回调
          // console.log('模型加载进度:', (xhr.loaded / xhr.total * 100) + '% loaded');
        },
        (error) => {
          // 加载错误回调
          console.error('模型加载失败:', error);
        }
      );
    },
    // 不需要每帧都渲染（尤其是静态场景）：
    animate(time) {
      this.animationId = requestAnimationFrame(this.animate);
      // 限制渲染频率
      const TARGET_FPS = 30;
      if (time - this.lastRender < 1000 / TARGET_FPS) return;
      this.lastRender = time;

      // 更新动画
      if (this.mixer) {
        this.mixer.update(0.05);
      }
      // 更新控制器
      if (this.controls) {
        this.controls.update();
      }
      // 渲染场景
      this.renderer.render(this.scene, this.camera);
    },
    onClick(event) {
      const rect = this.renderer.domElement;
      const mouse = new THREE.Vector2(
        (event.offsetX / rect.clientWidth) * 2 - 1,
        -(event.offsetY / rect.clientHeight) * 2 + 1
      );
      // 设置射线
      const raycaster = new THREE.Raycaster()
      raycaster.setFromCamera(mouse, this.camera);
      raycaster.firstHitOnly = true; // 只返回第一个相交点，大幅提速
      // 检测相交的对象，只考虑Mesh类型，并且限定为模型及其子对象
      const intersects = raycaster.intersectObjects(this.clickableObjects).filter(intersect => intersect.object instanceof THREE.Mesh);
      if (intersects.length > 0) {
        const target = intersects[0].object; // 代理对象
        console.log(target.name)
        if(this.type === 'wl'){
          if(target.name.indexOf('shuzhizhongxin')>-1){
            this.$router.push('/detail?type=wl&point=szzx')
          }
          if(target.name.indexOf('donglichejian')>-1){
            this.$router.push('/detail?type=wl&point=dlcj')
          }
          if(target.name.indexOf('kejixiaoyuan')>-1){
            this.$router.push('/detail?type=wl&point=kjxy')
          }
          if(target.name.indexOf('1haogongchang')>-1){
            this.$router.push('/detail?type=wl&point=1')
          }
          if(target.name.indexOf('2haogongchang')>-1){
            this.$router.push('/detail?type=wl&point=2')
          }
        }else{
          this.$router.push('/detail?type=xl&point=2')
        }
      }
    },
    onWindowResize() {
      const container = this.$refs.threeContainer;
      this.camera.aspect = container.clientWidth / container.clientHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(container.clientWidth, container.clientHeight);
    },
    cleanUp() {
      console.log("清理 Three.js 资源，防止内存泄漏")
      // 清理资源
      window.removeEventListener('resize', this.onWindowResize);
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
      if (this.controls) {
        this.controls.dispose();
        this.controls = null;
      }
      if (this.composer) {
        this.composer.renderTarget1.dispose();
        this.composer.renderTarget2.dispose();
        this.composer = null;
      }
      if (this.outlinePass) {
        if (this.outlinePass.renderTarget1) this.outlinePass.renderTarget1.dispose();
        if (this.outlinePass.renderTarget2) this.outlinePass.renderTarget2.dispose();
        this.outlinePass = null;
      }
      if(this.model){
        this.disposeModel(this.model)
        this.model = null
      }
      if(this.model2){
        this.disposeModel(this.model2)
        this.model2 = null
      }
      if (this.scene) {
        this.scene.clear();
        this.scene = null;
      }
      this.camera = null;
      if (this.renderer) {
        this.renderer.dispose();
        this.renderer.forceContextLoss();
        const canvas = this.renderer.domElement;
        if (canvas && canvas.parentNode) {
          canvas.parentNode.removeChild(canvas);
        }
        this.renderer = null;
      }
    },
    // 切换模型时销毁的 THREE.Mesh 或其父级 Group
    disposeModel(model) {
      // 遍历模型中的所有子对象
      model.traverse((child) => {
          if (child.isMesh) { // 如果是网格
              // 1. 释放几何体
              if (child.geometry) {
                  child.geometry.dispose();
              }
              // 2. 释放 material 和 textures
              if (child.material) {
                const materials = Array.isArray(child.material) ? child.material : [child.material];
                materials.forEach(mat => {
                  // 手动释放所有纹理
                  ['map', 'normalMap', 'emissiveMap', 'roughnessMap'].forEach(key => {
                    if (mat[key] && mat[key].isTexture) {
                      mat[key].dispose();
                    }
                  });
                  mat.dispose(); // 最后释放材质
                });
              }
          }
      });
      // 3. 从场景中移除该模型
      this.scene.remove(model);
    }
  },
};
</script>

<style lang="less" scoped>
@import '@/styles/subpage';
.flx{
  flex-wrap: wrap;
}
.main{
  position: relative;
}
.sbgl{
  position: absolute;
  .status{
    display: block;
    width: 122px;
    height: 50px;
    border-radius: 8px;
    background: #000;
    color: #fff;
    text-align: center;
    line-height: 50px;
    font-size: 26px;
  }
  .green{
    background: #50c350;
  }
  .blue{
    background: #33b2e9;
  }
  .red{
    background: #9b3434;
  }
}
.sbgl0{
  left: 78px;
  top: 251px;
}
.sbgl1{
  left: 300px;
  top: 251px;
}
.sbgl2{
  left: 534px;
  top: 251px;
}
.sbgl3{
  left: 70px;
  top: 554px;
}
.sbgl4{
  left: 300px;
  top: 554px;
}
.chart{
  width: 100%;
  height: 100%;
}
.video{
  width: 100%;
  height: 100%;
}
.main{
  position: relative;
  .hjjc{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 220px;
    display: flex;
    align-items: center;
    label{
      display: inline-block;
      width: 30px;
      margin: 0 20px 0 55px;
      line-height: 1;
      font-size: 36px;
    }
    .hjjc_info{
      width: calc(100% - 105px);
        height: 100%;
      display: flex;
      .item{
        width: 198px;
        height: 100%;
        text-align: center;
        padding-top: 66px;
        span{
          font-weight: bold;
          color:#fff600;
          font-size: 34px;
        }
        p{
          margin-top: 60px;
        }
      }
    }
  }
  .hjjc1{
    top: 220px;
  }
}
</style>